<div class="pricing-container">
    <div class="card" *ngFor="let plan of plans;let i = index; let first = first" [class.popular]="plan.planName === 'Business'">
        <h2 class="title" [ngClass]="{ 'green': plan.planName === 'Business', 'purple': plan.planName !== 'Business' }">{{ plan.planName }}</h2>
        <p class="description">{{ plan.planDetail }}</p>
        <div class="price-container">
            <p class="price">${{ plan.price }} {{ plan.planName === 'Enterprise' ? '' : 'USD' }}</p>
            <p class="frequency">Seat cost per month</p>
        </div>
        <button class="btn" [ngClass]="{ 'green': plan.planName === 'Business' }">{{ plan.planName === 'Enterprise' ? 'Contact sales' : 'Request a demo' }}</button>
        <p class="no-cc fw-400">No credit card required</p>
            {{ first ? 'Key Features :' : 'Everything in ' + plans[i - 1]?.planName + ', plus :' }}
        <ul class="features">
            <li *ngFor="let feature of plan.description.split(';')">{{ feature }}</li>
        </ul>
    </div>
</div>
<!-- <div class="pricing-container">
    <div class="card" *ngFor="let plan of plans; let i = index; let first = first" [class.popular]="plan.planName === 'Business'">
        <h2 class="title" [ngClass]="{ 'green': plan.planName === 'Business', 'purple': plan.planName !== 'Business' }">{{ plan.planName }}</h2>
        <p class="description">{{ plan.planDetail }}</p>
        <div class="price-container">
            <p class="price">${{ plan.price }} USD</p>
            <p class="frequency">Seat cost per month</p>
        </div>
        <button class="btn" [ngClass]="{ 'green': plan.planName === 'Business' }">{{ plan.planName === 'Enterprise' ? 'Contact sales' : 'Request a demo' }}</button>
        <p class="no-cc">No credit card required</p>
        <h6 class="features-title">
            <! Check if this is the first plan, display "Key Features", else display "Everything in [Previous Plan Name], plus:" -->
            <!-- {{ first ? 'Key Features:' : 'Everything in ' + plans[i - 1]?.planName + ', plus:' }}
        </h6>
        <ul class="features">
            <li *ngFor="let feature of plan.description.split(',')">{{ feature }}</li>
        </ul>
    </div> -->
<!-- </div>  -->